export enum ResultsStatuses {
  surveyIncomplete = 0,
  pendingReportReleaseDate = 10,
  pendingPayment = 20,
  resultsAvailable = 30
}
